<template>
    <Model :is-open="modelForm.is_open">
        <template #body>
            <div class="flex-grow">
                <div class="flex justify-between ">
                    <p class="text-lg font-medium ">Are your sure delete the Course?</p>
                </div>
            </div>
        </template>
        <template #buttons>
            <div class="flex justify-end">
                <Button @click="modelForm.is_open=false"
                        class="bg-red-600 text-primary-light hover:!bg-red-300 hover:border-white mx-4">Cancel
                </Button>
                <Button @click="handleRemoveEMI()" class="mr-2">Delete</Button>
            </div>
        </template>
    </Model>

    <internal>
        <div class="grid grid-cols-2 gap-4">
            <div
                class="p-6 bg-white border-b border-gray-200 overflow-y-scroll h-screen-80 shadow-sm sm:rounded-lg">
                <p class="text-lg font-medium mb-4">List Fees Type</p>
                <breeze-table :searchable="true"
                              :searchlink="route('internal.courseyear.list',branchid)"
                              :fields="fields"
                              :items="branchcourseyears"
                              :canView="hasRole('View Branch Course')">
                    <template #title="data">
                        {{ data.item.courseyear.course.title }} - {{ data.item.courseyear.title }} -
                        {{ data.item.courseyear.duration.start_month }}
                    </template>
                    <template #status="data">
                        {{ data.item.status ? 'Active' : 'Inactive' }}
                    </template>
                    <template #action="data">
                        <button-link :href="route('internal.courseyear.fee.list',[branchid,data.item.id])"
                                     :class="'mb-1 mr-2'"
                                     v-if="hasRole('View Branch Course')">
                            Fee
                        </button-link>
                        <button-link :href="route('internal.courseyear.results.list',[data.item.id])"
                                     :class="'mb-1 mr-2'">Upload Result
                        </button-link>
                        <button-link :href="route('internal.courseyear.edit',[branchid,data.item.id])" :class="'mb-1'"
                                     v-if="hasRole('Edit Branch Course')">
                            Edit
                        </button-link>

                        <Button @click="()=>{
                            modelForm.is_open=true;
                            modelForm.item=data.item;
                        }"
                                v-if="hasRole('Edit Branch Course')"
                                class="bg-red-600 text-primary-light hover:!bg-red-300 hover:border-white ml-2 translate-y-1">
                            <svg xmlns="http://www.w3.org/2000/svg"
                                 class="w-4 h-4  justify-self-center cursor-pointer"
                                 viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd"
                                      d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                      clip-rule="evenodd"></path>
                            </svg>
                        </Button>
                    </template>
                </breeze-table>
            </div>
            <div class="p-6 bg-white border-b border-gray-200 shadow-sm sm:rounded-lg">
                <loading :showLoading="form.processing"/>
                <div :class="{'opacity-50':form.processing,'opacity-100':!form.processing}">
                    <p class="text-lg font-medium mb-4">Add Course Year</p>
                    <form @submit.prevent="submitForm"
                          v-if="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Branch Course')">
                        <div class="grid grid-cols-8 gap-4 mb-8">
                            <div class="col-span-8 sm:col-span-8">

                                <FormMultiselect
                                    :required="true"
                                    label="Course Year"
                                    :options="options"
                                    track-key="id"
                                    label-key="title"
                                    :object="true"
                                    v-model="form.courseyear"
                                    :error="form.errors.courseyear"
                                />
                            </div>
                            <div class="col-span-2 sm:col-span-2">
                                <breeze-label :value="'Status'"/>
                                <breeze-checkbox v-model="form.status" :checked="form.status"/>
                                <breeze-input-error :message="form.errors?form.errors.status:''"/>
                            </div>
                        </div>
                        <breeze-button :disabled="form.processing">Submit</breeze-button>
                        <span v-if="form.recentlySuccessful" class="text-green-500 mx-4">Course Year Added!</span>
                        <exception/>
                    </form>
                    <div class="flex justify-center" v-else>
                        You have no permissions
                    </div>
                </div>
            </div>
        </div>
    </internal>
</template>

<script>
import Internal from '@/Pages/Internal/Internal'
import BreezeInput from '@/Components/Input'
import BreezeLabel from '@/Components/Label'
import ButtonLink from '@/Components/ButtonLink'
import CardHeader from '@/Components/CardHeader'
import {useForm} from '@inertiajs/inertia-vue3'
import BreezeInputError from '@/Components/InputError'
import BreezeButton from '@/Components/Button'
import BreezeCheckbox from '@/Components/Checkbox'
import Loading from '@/Components/Loading'
import Exception from '@/Components/Exception'
import BreezeTable from '@/Components/Table'
import SelectList from '@/Components/SelectList'
import FormMultiselect from "@/Components/Forms/FormMultiselect.vue";
import PopupModel from "@/Components/PopupModel.vue";
import Model from "@/Components/Model.vue";
import Button from "@/Components/Button.vue";
import {hasRole} from "../../../../Utils/checkPermission";

export default {
    components: {
        Button,
        Model,
        PopupModel,
        FormMultiselect,
        Internal,
        BreezeInput,
        BreezeLabel,
        ButtonLink,
        CardHeader,
        BreezeInputError,
        BreezeButton,
        BreezeCheckbox,
        Loading,
        Exception,
        BreezeTable,
        SelectList
    },
    props: ['courseyears', 'branchcourseyears'],
    data() {
        return {
            form: useForm({
                courseyear: '',
                status: true,
            }),
            branchid: localStorage.branchId,
            fields: [{'key': 'title', 'label': 'Title'}, {'key': 'status', 'label': 'Status'}, {
                'key': 'action',
                'label': 'Action'
            }],
            modelForm: {
                is_open: false,
                item: {},
            }

        }
    },
    methods: {
        hasRole,
        submitForm() {
            this.form.post(route('internal.courseyear.store', this.branchid), {
                preserveScroll: true,
                onSuccess: () => {
                    this.form.reset();
                    location.reload()
                },
            });
        },
        handleRemoveEMI() {

            this.form.post(route('internal.courseyear.destroy', [this.branchid, this.modelForm.item.id]), {
                preserveScroll: true,
                onSuccess: () => {
                    this.modelForm.is_open = false;
                    this.form.reset();
                    location.reload()
                },
            });
        }
    },
    computed: {
        options() {
            var options = [];
            this.courseyears.forEach(courseyear => {
                options.push({
                    id: courseyear.id,
                    title: courseyear.course.title + ' - ' + courseyear.title + ' - ' + courseyear.duration.start_month
                });
            });
            return options;
        },
    },
}
</script>
